import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGerritComponent } from './simple-icons-gerrit.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGerritComponent ],
    exports:      [ SimpleIconsGerritComponent ],
    bootstrap:    []
})
export class SimpleIconsGerritModule {}
